// extracted by mini-css-extract-plugin
module.exports = {"questionMarkContainer":"QuestionMark-questionMarkContainer-2XDXcy"};